<template>
  <div class="dial-table-container">
    <div class="left-table" v-if="dialInfo.base">
      <div class="table-header">{{ dialInfo.base[0].label }}</div>
      <div class="left-table-container">
        <div class="row" v-for="(row, rowIndex) in dialInfo.base" :key="`row-${rowIndex}`">
          <div class="show-row" v-if="row.label">
            <div class="header">{{ row.label }}</div>
            <div class="data" v-for="(properties, index) in row.properties" :key="`properties-${index}`">
              <span>{{ properties.data }}</span>
            </div>
            <div class="data" v-for="(data, index) in row.data" :key="`data-${index}`">
              <span>{{ data.data }}</span>
            </div>
          </div>
          <div v-if="rowIndex === 1">
            <div
              class="data total-row"
              v-for="(data, index) in dialInfo.baseTotals[rowIndex - 1].properties"
              :key="`totalData-${index}`"
            >
              <div v-if="data.data">{{ data.data }}</div>
            </div>
          </div>
          <div v-if="rowIndex === dialInfo.base.length - 1">
            <div
              class="data total-row"
              v-for="(data, index) in dialInfo.baseTotals[rowIndex - 3].data"
              :key="`totalData-${index}`"
            >
              <div v-if="data.data">{{ data.data }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-table" v-if="dialInfo.original">
      <div class="table-header">{{ dialInfo.original[0].label }}</div>
      <div class="right-table-container">
        <div class="row" v-for="(row, rowIndex) in dialInfo.original" :key="`row-${rowIndex}`">
          <div class="show-row" v-if="row.label && row.label !== 'Original'">
            <div class="header">{{ row.label }}</div>
            <div class="data" v-for="(properties, index) in row.properties" :key="`properties-${index}`">
              <span v-if="properties.ordinal !== '0'">{{ properties.data }}</span>
            </div>
            <div class="data" v-for="(data, index) in row.data" :key="`data-${index}`">
              <span v-if="data.ordinal !== '0'">{{ data.data }}</span>
            </div>
          </div>
          <div v-if="rowIndex === 1 && dialInfo.originalTotals[rowIndex - 1].dataName === 'Original Result'">
            <div
              class="data total-row"
              v-for="(data, index) in dialInfo.originalTotals[rowIndex - 1].data"
              :key="`totalData-${index}`"
            >
              <div v-if="data.data">{{ data.data }}</div>
            </div>
          </div>
          <div v-if="rowIndex === 2 && dialInfo.originalTotals[rowIndex - 1].dataName === 'Original Result Index'">
            <div
              class="data total-row"
              v-for="(data, index) in dialInfo.originalTotals[rowIndex - 1].data"
              :key="`totalData-${index}`"
            >
              <div v-if="data.data">{{ data.data }}</div>
            </div>
          </div>
          <div
            v-if="
              rowIndex === dialInfo.original.length - 1 &&
              dialInfo.originalTotals[rowIndex - 1].dataName === 'Original Result vs Target'
            "
          >
            <div
              class="data total-row"
              v-for="(data, index) in dialInfo.originalTotals[rowIndex - 1].data"
              :key="`totalData-${index}`"
            >
              <div v-if="data.data">{{ data.data }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-table" v-if="dialInfo.removals">
      <div class="table-header">{{ dialInfo.removals[0].label }}</div>
      <div class="right-table-container">
        <div class="row" v-for="(row, rowIndex) in dialInfo.removals" :key="`row-${rowIndex}`">
          <div class="show-row" v-if="row.label && row.label !== 'Removals'">
            <div class="header">{{ row.label }}</div>
            <div class="data" v-for="(properties, index) in row.properties" :key="`properties-${index}`">
              {{ properties.data }}
            </div>
            <div class="data" v-for="(data, index) in row.data" :key="`data-${index}`">
              {{ data.data }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-table" v-if="dialInfo.modified">
      <div class="table-header">{{ dialInfo.modified[0].label }}</div>
      <div class="right-table-container">
        <div class="row" v-for="(row, rowIndex) in dialInfo.modified" :key="`row-${rowIndex}`">
          <div class="show-row" v-if="row.label && row.label !== 'Normalized'">
            <div class="header" v-if="row.label">{{ row.label }}</div>
            <div class="data" v-for="(properties, index) in row.properties" :key="`properties-${index}`">
              <span v-if="properties.ordinal !== '0'">{{ properties.data }}</span>
            </div>
            <div class="data" v-for="(data, index) in row.data" :key="`data-${index}`">
              <span v-if="data.ordinal !== '0'">{{ data.data }}</span>
            </div>
          </div>
          <div v-if="rowIndex === 1">
            <div
              class="data total-row"
              v-for="(data, index) in dialInfo.modifiedTotals[rowIndex - 1].data"
              :key="`totalData-${index}`"
            >
              <div v-if="data.data">{{ data.data }}</div>
            </div>
          </div>
          <div v-if="rowIndex === 2">
            <div
              class="data total-row"
              v-for="(data, index) in dialInfo.modifiedTotals[rowIndex - 1].data"
              :key="`totalData-${index}`"
            >
              <div v-if="data.data">{{ data.data }}</div>
            </div>
          </div>
          <div v-if="rowIndex === 4">
            <div
              class="data total-row"
              v-for="(data, index) in dialInfo.modifiedTotals[rowIndex - 1].data"
              :key="`totalData-${index}`"
            >
              <div v-if="data.data">{{ data.data }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FD',
  components: {},
  props: {
    dialInfo: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
